import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateDocumentRequest extends BaseUpdateRequest {
    name: string;
    isExpiryTracked = false;
    expiresAt = '';
}